module.exports = __webpack_public_path__ + "img/4.f636b025.png";